import { Pipe, PipeTransform } from '@angular/core';
const ticksToDate = require('ticks-to-date');
var moment = require('jalali-moment');

@Pipe({
  name: 'ticksToTime',
})
export class TicksToTimePipe implements PipeTransform {

  transform(tick: number): string {
    const date = ticksToDate(tick);
    if (tick && date) {
      let minutes = date.getMinutes();
      let hours = date.getHours();
      minutes = minutes > 9 ? minutes : '0'+minutes;
      hours = hours > 9 ? hours : '0'+hours;
      const value = `${hours}:${minutes}`;
      return value;
    }else{
      return '-';
    }
  }

}
